var map = {
	"./tech-responsive-apache-airflow.svg": 4069,
	"./tech-responsive-artificial-intelligence.svg": 4070,
	"./tech-responsive-azure.svg": 4071,
	"./tech-responsive-chatgpt.svg": 4072,
	"./tech-responsive-copilot.svg": 4073,
	"./tech-responsive-data.svg": 4074,
	"./tech-responsive-excel.svg": 4075,
	"./tech-responsive-git.svg": 4076,
	"./tech-responsive-google-cloud.svg": 4077,
	"./tech-responsive-google-sheets.svg": 4078,
	"./tech-responsive-hugging-face.svg": 4079,
	"./tech-responsive-jupyter.svg": 4080,
	"./tech-responsive-langchain.svg": 4081,
	"./tech-responsive-llama.svg": 4082,
	"./tech-responsive-multiple.svg": 4083,
	"./tech-responsive-powerbi.svg": 4084,
	"./tech-responsive-powerpoint.svg": 4085,
	"./tech-responsive-python.svg": 4086,
	"./tech-responsive-r.svg": 4087,
	"./tech-responsive-sql.svg": 4088,
	"./tech-responsive-tableau.svg": 4089,
	"./tech-responsive-theory.svg": 4090
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3757;